export default "__VITE_ASSET__DejsEIcf__"